/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ClientRelationshipPatch,
  ClientResponse,
  HTTPValidationError
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Get Client
 */
export const getClient = (
    clientId: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<ClientResponse>(
      {url: `/clients/${clientId}`, method: 'GET', signal
    },
      options);
    }




export const getGetClientQueryKey = (clientId: string,) => {
    return [
    `/clients/${clientId}`
    ] as const;
    }


export const getGetClientQueryOptions = <TData = Awaited<ReturnType<typeof getClient>>, TError = HTTPValidationError>(clientId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClient>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientQueryKey(clientId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClient>>> = ({ signal }) => getClient(clientId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: clientId !== null && clientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClient>>, TError, TData> & { queryKey: QueryKey }
}

export type GetClientQueryResult = NonNullable<Awaited<ReturnType<typeof getClient>>>
export type GetClientQueryError = HTTPValidationError


/**
 * @summary Get Client
 */

export function useGetClient<TData = Awaited<ReturnType<typeof getClient>>, TError = HTTPValidationError>(
 clientId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClient>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetClientQueryOptions(clientId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Permanently delete a PROSPECT.
 *
 * 409 for anything that is a real client relationship: non-PROSPECT status,
 * linked brokerage accounts, or signed (WORM) compliance documents.
 * @summary Delete Client
 */
export const deleteClient = (
    clientId: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<void>(
      {url: `/clients/${clientId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteClientMutationKey = () => ['deleteClient'] as const;

export const getDeleteClientMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClient>>, TError,DeleteClientMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteClient>>, TError,DeleteClientMutationVariables, TContext> => {

const mutationKey = getDeleteClientMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteClient>>, DeleteClientMutationVariables> = (props) => {
          const {clientId} = props ?? {};

          return  deleteClient(clientId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteClientMutationResult = NonNullable<Awaited<ReturnType<typeof deleteClient>>>

    export type DeleteClientMutationError = HTTPValidationError
    export type DeleteClientMutationVariables = {clientId: string}

    /**
 * @summary Delete Client
 */
export const useDeleteClient = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClient>>, TError,DeleteClientMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteClient>>,
        TError,
        DeleteClientMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteClientMutationOptions(options));
    }
    /**
 * Change what the client IS to the firm — type, status, priority, source.
 *
 * The profile PATCH below covers the person. These four fields describe the
 * relationship, belong to no section of the paper application, and until now
 * had no write path at all: changing a client's type meant deleting the record
 * and re-creating it.
 * @summary Patch Client Relationship
 */
export const patchClientRelationship = (
    clientId: string,
    clientRelationshipPatch: ClientRelationshipPatch,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<ClientResponse>(
      {url: `/clients/${clientId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: clientRelationshipPatch, signal
    },
      options);
    }




export const getPatchClientRelationshipMutationKey = () => ['patchClientRelationship'] as const;

export const getPatchClientRelationshipMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchClientRelationship>>, TError,PatchClientRelationshipMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof patchClientRelationship>>, TError,PatchClientRelationshipMutationVariables, TContext> => {

const mutationKey = getPatchClientRelationshipMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchClientRelationship>>, PatchClientRelationshipMutationVariables> = (props) => {
          const {clientId,data} = props ?? {};

          return  patchClientRelationship(clientId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchClientRelationshipMutationResult = NonNullable<Awaited<ReturnType<typeof patchClientRelationship>>>
    export type PatchClientRelationshipMutationBody = ClientRelationshipPatch
    export type PatchClientRelationshipMutationError = HTTPValidationError
    export type PatchClientRelationshipMutationVariables = {clientId: string;data: ClientRelationshipPatch}

    /**
 * @summary Patch Client Relationship
 */
export const usePatchClientRelationship = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchClientRelationship>>, TError,PatchClientRelationshipMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchClientRelationship>>,
        TError,
        PatchClientRelationshipMutationVariables,
        TContext
      > => {
      return useMutation(getPatchClientRelationshipMutationOptions(options));
    }
